var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPause = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "pause")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2",
    "data-name": "Warstwa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_7",
    "data-name": "Warstwa 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm0,46.51A21.51,21.51,0,1,1,46.51,25,21.54,21.54,0,0,1,25,46.51Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.75,37.25h8.5V12.75h-8.5Zm2.5-22h3.5v19.5h-3.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75,12.75v24.5h8.5V12.75Zm6,22h-3.5V15.25h3.5Z",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPause, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause.db7a8934.svg";
export { ForwardRef as ReactComponent };